export const roleMemberInChat = 'roleMemberInChat'
export const roleAdminInChat = 'roleAdminInChat'
export const roleReaderInChat = 'roleReaderInChat'

export const rolesChatParticipants = {
    1: roleMemberInChat,
    2: roleAdminInChat,
    3: roleReaderInChat,
}